import { render, staticRenderFns } from "./DocumentsSelect.vue?vue&type=template&id=7ad3229c&"
import script from "./DocumentsSelect.vue?vue&type=script&lang=js&"
export * from "./DocumentsSelect.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsSelect.vue?vue&type=style&index=0&id=7ad3229c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports